import { buildInstantAccessRedirectUrl } from "../ui/auth/xrhubAuthHandoff.js";
import {
  AUTH_MODE_INSTANT,
  AUTH_MODE_KEY,
  INSTANT_ACCESS_SID_KEY,
  INSTANT_ACCESS_SID_PATTERN,
  resolveAuthMode,
  resolveInstantAccessSid
} from "./reauthHints.js";

export { AUTH_MODE_INSTANT, AUTH_MODE_KEY, INSTANT_ACCESS_SID_KEY, INSTANT_ACCESS_SID_PATTERN };

export function handleInstantAccessTokenExpiry({
  storage = localStorage,
  location = window.location,
  routerBasePath = "",
  clearAuthCookie = () => {},
  xrhubUrl = ""
} = {}) {
  const authMode = resolveAuthMode(storage);
  if (authMode !== AUTH_MODE_INSTANT) {
    return false;
  }

  const instantAccessSid = resolveInstantAccessSid(storage);
  storage.removeItem("auth0token");
  clearAuthCookie();

  const hasValidInstantSid = typeof instantAccessSid === "string" && INSTANT_ACCESS_SID_PATTERN.test(instantAccessSid);
  location.assign(
    buildInstantAccessRedirectUrl({
      instantAccessSid: hasValidInstantSid ? instantAccessSid : "",
      xrhubUrl,
      locationOrigin: location.origin,
      creatorBasePath: routerBasePath
    })
  );
  return true;
}
